'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.itemClassName = undefined;

var _animation = require('./animation');

var isActiveItem = function isActiveItem(i, state) {
  var currentIndex = state.currentIndex,
      items = state.items,
      stagePadding = state.stagePadding;

  if (stagePadding.paddingLeft || stagePadding.paddingRight) {
    currentIndex += 1;
  }
  return currentIndex + items === i;
};

var isClonedItem = function isClonedItem(i, state) {
  var items = state.items,
      slides = state.slides,
      infinite = state.infinite;

  return infinite === false && (i < items || i > slides.length + items - 1);
};

var itemClassName = function itemClassName(i, state, animationProps) {
  var isActive = isActiveItem(i, state) ? ' __active' : '';
  var isCloned = isClonedItem(i, state) ? ' __cloned' : '';
  var isAnimated = (0, _animation.isAnimatedItem)(i, animationProps) ? ' animated animated-out fadeOut' : '';

  return 'alice-carousel__stage-item' + isActive + isCloned + isAnimated;
};

exports.itemClassName = itemClassName;